import axios, { AxiosInstance } from 'axios';

export type IntercomTokens = {
    web?: string;
    android?: string;
    ios?: string;
};

export type IntercomError = {
    error: string;
};

class IntercomAuthLambda {
    private axiosInstance: AxiosInstance;

    constructor() {
        const baseUrl = import.meta.env.VITE_APP_INTERCOM_AUTH_URL || '';
        this.axiosInstance = axios.create({
            baseURL: baseUrl
        });
    }

    /**
     * Call Intercom Auth Lambda
     * @param userToken - token from main authentication flow
     * @returns IntercomTokens
     */
    async post(userToken: string): Promise<IntercomTokens> {
        const env = import.meta.env.VITE_ENV;
        if (!userToken) {
            throw new Error('Missing user token for Intercom auth');
        }

        if (!env) {
            throw new Error('Missing environment variable for Intercom auth');
        }

        try {
            const response = await this.axiosInstance.post<IntercomTokens>(
                '',
                {
                    env
                },
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`
                    }
                }
            );
            if (!response?.data || Object.keys(response.data).length === 0) {
                throw new Error('No tokens returned from Intercom auth');
            }
            return response.data;
        } catch (err: any) {
            console.error('Intercom auth error:', err.response?.data || err.message);
            throw err;
        }
    }
}

const intercomAuthInstance = new IntercomAuthLambda();
export default intercomAuthInstance;
